/*
* Treeview 1.4 - jQuery plugin to hide and show branches of a tree
* 
* http://bassistance.de/jquery-plugins/jquery-plugin-treeview/
* http://docs.jquery.com/Plugins/Treeview
*
* Copyright (c) 2007 Jörn Zaefferer
*
* Dual licensed under the MIT and GPL licenses:
*   http://www.opensource.org/licenses/mit-license.php
*   http://www.gnu.org/licenses/gpl.html
*
* Revision: $Id: jquery.treeview.js 4684 2008-02-07 19:08:06Z joern.zaefferer $
*
*/

; (function($) {

	$.extend($.fn, {
		collapsible: function(options) {
			var settings = { collapsed: false };
			$.extend(settings, options);
			// Set up collapsible panel
			// set UI theming

			var h3 = $(this).children('h3');
			h3.addClass('ui-collapsible-header ui-helper-reset ui-widget-header ui-corner-top');

			var $this = $(this);

			$(this).addClass('ui-collapsible ui-widget ui-helper-reset');

			$(this).children('div').addClass('ui-collapsible-content ui-helper-reset ui-widget-content ui-corner-bottom');
			$(this).children('div').show();
			// Add image icon
			// <a class="ui-dialog-titlebar-close ui-corner-all" href="#" role="button" unselectable="on" style="-moz-user-select: none;">
			//   <span class="ui-icon ui-icon-triangle-1-s" unselectable="on" style="-moz-user-select: none;">close</span>
			// </a>
			var iconPanel = $("<span></span>").addClass('ui-collapsible-header-buttonpane').appendTo(h3);
			var iconSpan = $("<span></span>").addClass('ui-button').appendTo(iconPanel);
			var parentId = $(this).attr("id");
			if (parentId != null) {
				parentId = parentId + "CollapseButton"
				iconSpan.attr("id", parentId);
			}
			if (options.buttons) {
				for (var key in options.buttons) {
					var iconSpan2 = $("<span></span>").addClass('ui-button').appendTo(iconPanel);
					if (key != "help") {
						var iconIcon2 = $("<a></a>").attr("href", options.buttons[key].url).html(options.buttons[key].text).appendTo(iconSpan2);
						if (options.buttons[key].target)
							iconIcon2.attr("target", options.buttons[key].target);
						iconSpan2.addClass('ui-state-default');
						iconSpan2.mouseover(function() { $(this).addClass('ui-state-hover'); }).mouseout(function() { $(this).removeClass('ui-state-hover'); });
					} else {
						// Add help icon
						var iconIcon2 = $("<a></a>").attr("href", options.buttons[key].url).addClass('ui-icon ui-icon-help2').appendTo(iconSpan2);
						if (options.buttons[key].target)
							iconIcon2.attr("target", options.buttons[key].target);
						iconSpan2.addClass('ui-state-default');
						iconSpan2.mouseover(function() { $(this).addClass('ui-state-hover'); }).mouseout(function() { $(this).removeClass('ui-state-hover'); });
					}

				}
			}


			var iconIcon = $("<span></span>").addClass('ui-icon').html('close').appendTo(iconSpan);

			iconSpan.addClass('ui-state-default');
			iconSpan.mouseover(function() { $(this).addClass('ui-state-hover'); }).mouseout(function() { $(this).removeClass('ui-state-hover'); });

			iconSpan.click(function () {
			  var isexpanding = $(this).find('.ui-icon').is('.ui-icon-triangle-2-s');
	
			  var collapsingPanel = $(this).parent().parent().next();
			  if (collapsingPanel.is('.is-resizing'))
			    return;
			  collapsingPanel.addClass('is-resizing');
			  collapsingPanel.parent().attr('data-panel-state', isexpanding ? "expanded" : "collapsed");
				if (collapsingPanel.is(":hidden")) {
					// Load div from action URL if defined.
					
					
					if ($(this).parent().parent().parent().attr('AutoLoadURL') && collapsingPanel.children().html().toUpperCase() == '<DIV></DIV>') {
					
						collapsingPanel.children().eq(0).load($(this).parent().parent().parent().attr('AutoLoadURL'));
					}

					$(this).parent().parent().removeClass("ui-corner-all");
					$(this).parent().parent().addClass("ui-corner-top");
				} else {
				  //need a pre event when collapsing so we can hide nested containers
				  collapsingPanel.trigger({ type: "beforePanelStateCollapse", panelName: $this.attr("id"), expanding: isexpanding });
				}
				// Have to add 'fake' event trigger in here.
				// Because jQuery UI doesn't trigger any events for the resizing of the div - use an interval
				// and trigger event every 50ms until the animation is complete.
				var isHidden = true;
				var evtInterval = window.setInterval(function() {
					// Trigger resize
					collapsingPanel.trigger("resize");
				}, 100);
				if (!collapsingPanel.is(":hidden")) 
				  isHidden = false;
				collapsingPanel.trigger({ type: "beforePanelState", isHidden: isHidden, panelName: $this.attr("class"), expand: isexpanding });

				collapsingPanel.slideToggle('slow', function() {
					// slide is done, clear the interval!
					window.clearInterval(evtInterval);
					//  collapsingPanel.trigger("resize");
					if ($(this).is(":hidden")) {
						$(this).prev().removeClass("ui-corner-top");
						$(this).prev().addClass("ui-corner-all");
						iconIcon.removeClass('ui-icon-triangle-2-n');
						iconIcon.addClass('ui-icon-triangle-2-s');
					} else {
						isHidden = false;
						iconIcon.removeClass('ui-icon-triangle-2-s');
						iconIcon.addClass('ui-icon-triangle-2-n');
					}
					collapsingPanel.trigger({ type: "panelState", isHidden: isHidden, panelName: $this.attr("class"), expand: isexpanding });
				  collapsingPanel.removeClass('is-resizing');
				});
				
				return false;
			})
			if (settings.collapsed) {
				$(this).children('h3').next().hide();
				iconIcon.addClass('ui-icon-triangle-2-s');
			} else {
				iconIcon.addClass('ui-icon-triangle-2-n');
			}
		},
		toogle: function(expand) {
			var parentId = $(this).attr("id");
			if (parentId != null) {
				buttonId = parentId + "CollapseButton";
				var btn = $("#" + buttonId);

				if (expand) {
					var isCollapsed = btn.find('.ui-icon-triangle-2-n');
					if (isCollapsed.length == 0) {
						btn.click();
					}
				}
				else {
					var isCollapsed = btn.find('.ui-icon-triangle-2-s');
					if (isCollapsed.length == 0) {
						btn.click();
					}
				}
			}

		}
	});



})(jQuery);